// extracted by mini-css-extract-plugin
module.exports = {"collection-manage":"story-manage_collection-manage__2JYR5","set-page-views":"story-manage_set-page-views__26jlc"};